import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
@Injectable()
export class ModPreloginService {

    private queryString = '?user_id=NXI_API_GOLD_USER';
    private modMarketIndicesUri = '/portal/holdingsperf?symbols=.indu|comp.idx|spx&user_id=NXI_API_GOLD_USER';

    constructor(private http: HttpClient) {
    }

     getModPreloginComponentRespose (modAPIUrl: string, compoentName: string): Observable<any> {
         return this.http.jsonp(modAPIUrl + '/portal/' + compoentName + this.queryString, 'callback');
     }

    getModMarketIndicesRespose (modAPIUrl: string): Observable<any> {
        return this.http.jsonp(modAPIUrl + this.modMarketIndicesUri, 'callback');
    }

}
